import React from 'react';

const PubNubLogo = props => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#CD2028" d="M0 0h32v32H0z" />
      <path
        d="M5.509 17.87c-.001.148.05.21.19.26.984.358 2 .553 3.053.54.92-.012 1.758-.25 2.394-.935.435-.47.653-1.039.757-1.645.25-1.449.212-2.891-.206-4.31-.286-.972-.907-1.654-1.963-1.92-.555-.14-1.121-.143-1.686-.104a9.05 9.05 0 0 0-2.337.484c-.147.05-.203.113-.202.269.007 1.227.004 2.453.004 3.68 0 1.227.003 2.454-.004 3.68zM9.255 8c.047.012.094.03.142.036.308.04.62.062.925.118 1.995.366 3.302 1.458 3.854 3.345.31 1.062.396 2.148.377 3.244-.015.903-.146 1.787-.484 2.637-.739 1.858-2.289 2.925-4.366 3.011-1.315.054-2.579-.167-3.809-.596l-.386-.131V25H3.004v-.23c0-5.18.001-10.36-.004-15.54 0-.173.051-.256.222-.316 1.24-.44 2.52-.7 3.831-.837.25-.027.502-.051.752-.077h1.45zM24.12 8c.324.039.65.07.973.117.77.11 1.506.316 2.174.692 1.04.585 1.571 1.456 1.69 2.549.035.31.04.625.041.939.003 2.583.002 5.166.002 7.749v.229h-2.656v-.24c0-2.319.003-4.637-.002-6.956-.002-.579-.056-1.154-.244-1.712-.311-.92-1.008-1.443-2.038-1.555-1.263-.137-2.508-.002-3.733.308-.174.044-.227.12-.227.283.005 3.21.004 6.421.004 9.632v.243h-2.655v-.24c0-3.653.001-7.306-.005-10.96 0-.177.053-.252.247-.3a26.523 26.523 0 0 1 4.74-.746c.052-.004.102-.021.153-.032h1.535z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export default PubNubLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/PubNubLogo.es6.js